import { redirect, createFileRoute } from '@tanstack/react-router'
import { getOidc } from '@/features/oidc/oidc'

export const Route = createFileRoute('/register')({
  beforeLoad: async () => {
    const oidc = await getOidc()

    if (oidc.isUserLoggedIn) {
      return redirect({ to: '/' })
    }

    await oidc.login({
      doesCurrentHrefRequiresAuth: false,
      transformUrlBeforeRedirect: (url) => {
        const urlObj = new URL(url)

        urlObj.pathname = urlObj.pathname.replace(/\/auth$/, '/registrations')

        return urlObj.href
      },
    })
  },
})
